<template>
    <section>
        <section id="music" class="tw-py-12 tw-relative">
            <div class="gradient" :style="{'background-color': bgColor}"></div>
            <div class="tw-container tw-mx-auto tw-relative">
                <div class="tw-flex tw-w-full tw-flex-col md:tw-flex-row tw-items-center">
                    <v-img aspect-ratio="1/1" id="coverImg" :src="spotifyAlbum.images[0].url" class="tw-py-2 tw-shadow-lg tw-rounded-sm" height="180" width="180"></v-img>
                    <div class="md:tw-ml-8 tw-py-4 tw-flex tw-flex-col tw-justify-between middle">
                        <div class="tw-items-start tw-text-left tw-flex tw-flex-col tw-w-full">
                            <div class="tw-justify-center md:tw-justify-start tw-flex tw-items-center tw-w-full">
                                <h3 class="tw-font-sans tw-text-white tw-text-2xl md:tw-text-3xl lg:tw-text-4xl xl:tw-text-5xl tw-font-extrabold tw-m-0 tw-truncate">{{spotifyAlbum.name}}</h3>
                            </div>
                            <div class="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-w-full tw-truncate">
                                <a href="#!" class="tw-font-sans tw-text-white tw-text-sm lg:tw-text-base tw-font-bold tw-m-0 tw-mt-2 tw-tracking-tighter tw-ml-1 tw-truncate" v-for="(artist, index) in spotifyAlbum.artists" :key="artist.id">
                                    <span>{{artist.name}}</span>
                                    <span v-if="index !== spotifyAlbum.artists.length - 1" class="dot"></span>
                                </a>
                            </div>
                        </div>
                        <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-mt-5 tw-justify-center md:tw-justify-start">
                            <a :href="album.sharedlink" target="_blank" v-if="album && album.sharedlink.length" v-ripple class="tw-px-4 tw-py-2 tw-bg-white tw-rounded-sm tw-font-sans tw-text-black tw-text-xs tw-tracking-wide tw-uppercase">{{selectedLanguageObj.listen}}</a>
                            <div class="tw-flex tw-mt-3 md:tw-mt-0 tw-items-center">
                                <span class="dot tw-mx-2 tw-hidden md:tw-block"></span>
                                <div class="tw-font-sans tw-text-white tw-font-semibold tw-text-sm">
                                    {{getReleaseYear()}}
                                </div>
                                <span class="dot tw-mx-2"></span>
                                <v-dialog v-model="dialog" max-width="450" transition="scroll-y-transition">
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="tw-border-gray-800" v-on="on" fab light outlined x-small color="white">
                                            <v-icon class="tw-text-sm">fas fa-share-alt</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-toolbar dark color="purple">
                                            <v-btn icon dark small class="tw-ml-1" @click="dialog = false">
                                                <v-icon class="tw-text-sm">fas fa-times</v-icon>
                                            </v-btn>
                                            <v-toolbar-title class="tw-font-sans tw-pl-2">{{selectedLanguageObj.share}}</v-toolbar-title>
                                        </v-toolbar>
                                        <div class="tw-px-2 tw-py-4">
                                            <div class="tw-px-2">
                                                <div class="tw-flex tw-items-center tw-flex-wrap tw--mx-2">
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn :href="shareLinks['facebook']" block dark outlined class="tw-font-sans tw-text-xs tw-relative tw-mb-3">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fab fa-facebook</v-icon>
                                                            Facebook
                                                        </v-btn>
                                                    </div>
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn :href="shareLinks['twitter']" block dark outlined class="tw-font-sans tw-text-xs tw-relative tw-mb-3">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fab fa-twitter</v-icon>
                                                            Twitter
                                                        </v-btn>
                                                    </div>
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn :href="shareLinks['whatsapp']" block dark outlined class="tw-font-sans tw-text-xs tw-relative tw-mb-3 md:tw-mb-0">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fab fa-whatsapp</v-icon>
                                                            Whatsapp
                                                        </v-btn>
                                                    </div>
                                                    <div class="tw-w-full md:tw-w-1/2 tw-px-2">
                                                        <v-btn :href="'mailto:?subject=Olha essa álbum!&amp;body=Olha esse álbum que encontrei na MusicPro: '+currentUrl" block dark outlined class="tw-font-sans tw-text-xs tw-relative">
                                                            <v-icon right dark class="tw-text-sm tw-absolute tw-left-0 tw--ml-1">fas fa-envelope</v-icon>
                                                            E-Mail
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <v-divider></v-divider>
                                        <div class="tw-px-4 tw-py-4">
                                            <div class="tw-w-full tw-flex tw-items-center tw-py-2 tw-px-3 tw-border tw-rounded tw-justify-between" id="shareLink">
                                                <input type="text" :value="currentUrl" readonly class="tw-opacity-0 tw-absolute tw-top-0 tw-w-2" id="pen-url">
                                                <div class="tw-mr-4 tw-text-sm tw-font-light tw-truncate tw-font-sans tw-opacity-40 tw-cursor-default tw-pointer-events-none">{{ currentUrl }}</div>
                                                <button @click="copyText()" class="tw-h-full tw-px-6 tw-py-2 tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-font-sans tw-uppercase tw-text-xs tw-whitespace-no-wrap tw-rounded" v-ripple>{{selectedLanguageObj.copy}}</button>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="shows" class="tw-block tw-py-8 tw-mb-12">
        <div class="tw-container tw-mx-auto">
             <div class="tw-flex tw-justify-between tw-w-full tw-items-center tw-px-4 md:tw-px-0">
                <h6 class="tw-text-white tw-font-sans">Tracklist</h6>
            </div>
            <div class="tw-flex tw-flex-col tw-mt-3">
                <div class="tw-border-b tw-border-gray-700 tw-px-4" v-for="(track, index) in tracks" :key="index">
                    <div class="tw-flex tw-flex-row">
                        <div class="tw-flex tw-flex-row tw-flex-grow tw-border-l-0 tw-h-auto event-wrapper">
                            <div class="tw-flex tw-flex-1 tw-flex-col md:tw-flex-row">
                                <div class="event-date">
                                    <v-img aspect-ratio="1/1" id="coverImg" :src="track.album.images[0].url" class="tw-py-2 tw-shadow-lg tw-rounded-sm" height="50" width="50"></v-img>
                                </div>
                                <div class="tw-flex tw-flex-1 tw-flex-row tw-items-center">
                                    <div class="event-details">
                                        <div class="event-details__header">
                                            <div class="event-details__inner tw-truncate">
                                                <div class="tw-block tw-w-full">
                                                    <inertia-link :href="tenant ? `/track/${track.id}` : `/track/${artist.artista_url}/${track.id}`" class="tw-font-sans tw-truncate tw-text-white tw-text-base tw-leading-5">{{track.name}}</inertia-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-actions tw-hidden xl:tw-flex tw-justify-center">
                            <inertia-link :href="tenant ? `/track/${track.id}` : `/track/${artist.artista_url}/${track.id}`" v-ripple>{{selectedLanguageObj.access}}</inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </section> 
</template>

<script>
import Layout from '@/Shared/SingleLayout';
import moment from 'moment';
import rgbaster from 'rgbaster'
window.moment = global.moment = moment;
window.rgbaster = global.rgbaster = rgbaster;
import Single from '@/components/single'; 
import EventBus from '@/eventbus';
import pt from '../lang/album.js';

export default {
    mixins: [pt],
    layout: (h, page) => h(Layout, [page]),
    layout: Layout,
    metaInfo() {
        return {
            title: `${this.beat.name}`,
        }
    },
    props: ['tracks', 'album', 'spotifyAlbum', 'artist', 'spotifyArtist', 'shareLinks', 'pageOptions'],
    components: {Single},
    data(){
        return{
            tab: null,
            bgColor: '',
            playing: false,
            loading: false,
            waves: '',
            dialog: false,
            currentUrl: '',
            snackBar: false,
            selectedLanguageObj: {}
        }
    },
    methods: {
        visit(isrc, id){
            this.$inertia.visit(`/single/${this.artist.artista_url}/${isrc}`, {
                method: 'get',
                replace: false,
                preserveState: false,
                preserveScroll: false,
                only: [],
            });
        },
        copyText(){
            var copyText = document.querySelector("#pen-url");
            copyText.select();
            document.execCommand("copy")
            this.snackBar = true;
        },
        getReleaseYear(){
            return moment(this.spotifyAlbum.release_date, 'YYYY-MM-DD').format('YYYY');
        },
        setLanguage() {
            if(this.$page.props.lang == 'US') {
                this.selectedLanguageObj = pt.data().en
            } else {
                this.selectedLanguageObj = pt.data().pt
            }
        }
    },
    created(){
        this.currentUrl = window.location;
    },
    mounted(){
        this.setLanguage();
        const vm = this;
        setTimeout(() => {
            EventBus.$emit('artist', {'pageOptions': this.pageOptions, 'artist': this.artist, 'spotifyArtist': this.spotifyArtist});
        }, 10);

        async function color(){
            const result = await rgbaster(vm.spotifyAlbum.images[0].url);
            vm.bgColor = result[1].color;
        }
        color();
    },
}
</script>

<style scoped>
    .middle{
        width: calc(100% - 40px);
    }
    @media (min-width: 768px){
        .middle{
            width: calc(100% - 180px - 2rem);
        }
    }
    .dot::before{
        content: "\2022";
        margin: 0 4px;
    }
    .gradient{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        background: linear-gradient(to bottom,rgba(0,0,0,.3),rgba(27,27,27,.56) 0%,#1f1f1f);
        transition: background-color .2s ease-in-out;
    }
    #shareLink{
        border-color: rgba(255, 255, 255, 0.12)!important;
    }

.event-wrapper{
    padding: 15px 0px;
    margin: 0px 24px 0px 0px;
    max-height: 300px;
    border-left: none;
}
.event-date {
    display: flex;
    margin-bottom: 8px;
    flex-flow: row wrap;
}
@media screen and (min-width: 768px){
    .event-date {
        margin-bottom: 0px;
        margin-right: 8px;
        width: 7ch;
        flex-flow: column nowrap;
    }
}
.event-details{
    display: grid;
    grid-template-areas: "header";
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    width: 100%;
}
.event-details__header{
    display: flex;
    flex-flow: row;
    grid-area: header / header / header / header;
}
.event-details__inner{
    max-height: 600px;
    opacity: 1;
    visibility: visible;
    transition: max-height 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s, opacity 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.2s, margin-bottom 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    align-items: flex-start;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    flex: 1 1 0%;
    flex-flow: row;
    max-width: 80vw;
}
@media(min-width:1280px){
    .event-details__inner{
        max-width: 950px;
    }
}
.right-actions{
    display: flex;
    flex-shrink: 0;
    flex-flow: column;
}
.right-actions a{
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    text-align: center;
    font-weight: 600;
    line-height: 36px;
    margin-bottom: 4px;
    max-height: 36px;
    min-width: 106px;
    font-weight: 600;
    font-size: 14px;
    line-height: 2.43;
    width: 100%;
    min-width: 60px;
    text-align: center;
    text-transform: capitalize;
    cursor: pointer;
    color: rgb(255, 255, 255);
    background-color: rgb(2, 108, 223);
    display: block;
    padding: 0px 12px;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    border-image: initial;
    transition: background-color 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    text-decoration: none;
}
</style>